<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="fe fe-credit-card" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Claims Payment Orders</h4>
                <small style="opacity: .8;">{{ payments.total || 0 }} payment order(s) on record</small>
              </div>
            </div>
            <button type="button" class="btn btn-outline-light btn-sm" @click="getPayments">
              <i class="fe fe-refresh-cw mr-1"></i> Refresh
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Payment Orders Table ── -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-list text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">Payments</h6>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Date</th>
                  <th class="table-th">Payment Order Number</th>
                  <th class="table-th">Recipient</th>
                  <th class="table-th">Status</th>
                  <th class="table-th">Total Claims</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="payment in payments.data" v-bind:key="payment.id">
                  <td class="py-2" style="font-size:.85rem;">{{ payment.created_at }}</td>
                  <td class="py-2"><span class="code-chip">#{{ payment.payment_number }}</span></td>
                  <td class="py-2">{{ payment.provider.agency_name }}</td>
                  <td class="py-2">
                    <span class="badge badge-soft-success" v-if="payment.status == 'paid'">
                      <i class="fe fe-check-circle mr-1"></i> {{ payment.status }}
                    </span>
                    <span class="badge badge-soft-warning" v-if="payment.status == 'pending'">
                      <i class="fe fe-clock mr-1"></i> {{ payment.status }}
                    </span>
                  </td>
                  <td class="py-2 font-weight-bold">{{ payment.claims_count }}</td>
                  <td class="py-2">
                    <a :href="`/transaction/${payment.id}`" class="btn btn-sm btn-outline-primary">
                      <i class="fe fe-eye mr-1"></i> View Payment Order
                    </a>
                  </td>
                </tr>
                <tr v-if="!payments.data || !payments.data.length">
                  <td colspan="6" class="text-center py-5 text-muted">
                    <i class="fe fe-inbox" style="font-size:2rem;opacity:0.3;"></i>
                    <p class="mt-2 mb-0">No payment orders found</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body pt-2" v-if="payments.total">
            <b-pagination v-model="currentPage" :total-rows="payments.total" :per-page="payments.per_page || 15"
              @input="getPayments(currentPage ? currentPage : 1)"></b-pagination>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        agency: agency,
        isLoading: false,
        fullPage: true,
        states: "",
        user: null,
        employees: "",
        state: "",
        payments: "",
        currentPage: 1,

      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));

    },
    methods: {
      getPaymentAgency(currentPage) {
        this.axios
          .get(`/api/v1/auth/paymentorder-agency/${agency.id}`, {
            params: {
              type: 'claims',
              page: currentPage,
            }
          })
          .then((response) => {
            this.payments = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getPaymentProvider(currentPage) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/paymentorder-provider/${this.user.id}`, {
            params: {
              type: 'claims',
              page: currentPage,
            }
          })
          .then((response) => {
            this.payments = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getPayments(currentPage) {
        this.user = JSON.parse(localStorage.getItem("user"));
        if (this.user.type == 'employee' || this.user.type == 'shis') {
          this.getPaymentAgency(currentPage)

        } else {
          this.getPaymentProvider(currentPage)
        }
      }


    },
    created() {
      this.getPayments()
    },
  };
</script>
